import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-site-banner",
  templateUrl: "./site-banner.component.html",
  styleUrl: "./site-banner.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteBannerComponent {
  isOpenBanner = false;
}
